import React, { useState } from "react";
import PageHeader from "../../components/general/page-header";
import { Button, Flex, Input, Space, Tabs, Tag } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import Table from "../../components/table-components/table";
import EditBtn from "../../components/table-components/actions/edit-btn";
import ViewBtn from "../../components/table-components/actions/view-btn";
import DeleteBtn from "../../components/table-components/actions/delete-btn";
import type { TableColumnsType, TableProps } from "antd";
import { FilterFilled } from "@ant-design/icons";

import dayjs from "dayjs";
interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

const questionsData = Array.from({ length: 20 }, (_, index) => ({
  key: index + 1,
  lang: index % 2 === 0 ? "العربية" : "English",
  question: `ما هي عاصمة الدولة رقم ${index + 1}?`,
  choiceOne: "الخيار الأول",
  choiceTwo: "الخيار الثاني",
  choiceThree: "الخيار الثالث",
  answer: "الخيار الأول",
  points: (index + 1) * 5,
  category: ["جغرافيا", "تاريخ", "علوم", "رياضة"][index % 4],
  level: ["سهل", "متوسط", "صعب"][index % 3],
  date: new Date().toISOString(),
}));

const Questions = () => {
  const defaultColumns: any[] = [
    {
      title: "اللغة",
      dataIndex: "lang",
      align: "center",
      key: "lang",
      sorter: true,
    },
    {
      title: "السؤال",
      dataIndex: "question",
      align: "center",
      key: "question",
      sorter: true,
    },
    {
      title: "الخيار الأول",
      dataIndex: "choiceOne",
      align: "center",
      key: "choiceOne",
      sorter: true,
    },
    {
      title: "الخيار الثاني",
      dataIndex: "choiceTwo",
      align: "center",
      key: "choiceTwo",
      sorter: true,
    },
    {
      title: "الخيار الثالث",
      dataIndex: "choiceThree",
      align: "center",
      key: "choiceThree",
      sorter: true,
    },
    {
      title: "الجواب",
      dataIndex: "answer",
      align: "center",
      key: "answer",
      sorter: true,
    },
    {
      title: "النقاط",
      dataIndex: "points",
      align: "center",
      key: "points",
      sorter: true,
    },
    {
      title: "فئة",
      dataIndex: "category",
      align: "center",
      key: "category",
      sorter: true,
    },
    {
      title: "المستوى",
      dataIndex: "level",
      align: "center",
      key: "level",
      sorter: true,
    },

    {
      title: "تاريخ الانشاء",
      dataIndex: "date",
      sorter: true,

      align: "center",

      render: (text: string) =>
        dayjs(new Date()).format("hh:mm A YYYY-MM-DD") || "-",
      key: "Notes",
    },
    {
      title: "أزرار",
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record: any) => (
        <Space>
          <ViewBtn />

          <EditBtn />

          <DeleteBtn onConfirm={async () => {}} />
        </Space>
      ),
    },
  ];
  const rowSelection: TableProps<DataType>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };

  const [selectionType, setSelectionType] = useState<"checkbox" | "radio">(
    "checkbox"
  );

  return (
    <>
      <PageHeader title={"أسئلة/قائمة الأسئلة"}>
        <Tabs>
          <TabPane tab={"أسئلة"} key={0}></TabPane>
          <TabPane tab={"التصنيفات"} key={1}></TabPane>
          <TabPane tab={"التصنيفات الفرعية"} key={2}></TabPane>
        </Tabs>
      </PageHeader>

      <div
        style={{
          background: "white",
          borderRadius: "10px",
          marginTop: "10px",
          boxShadow: "0 0.125rem 0.25rem rgba(28, 43, 54, 0.075)",
          padding: "1rem",
        }}
      >
        <Flex justify="space-between">
          <Input.Search
            placeholder="بحث"
            style={{ width: "30%" }}
            variant="filled"
          />

          <Flex gap={9} style={{ marginInlineEnd: "5px" }}>
            <button className="excel-button">استيراد ملف اكسل</button>

            <Button
              type="text"
              style={{ background: "#b2bec34a" }}
              icon={<FilterFilled />}
            ></Button>

            <Button type="text" style={{ background: "#b2bec34a" }}>
              اضافة سؤال
            </Button>
          </Flex>
        </Flex>
        <Table<any>
          rowSelection={{ type: selectionType, ...rowSelection }}
          rowKey="key"
          // showPagination={true}
          size="small"
          columns={defaultColumns as any}
          dataSource={questionsData}
          pagination={{
            pageSize: 10,
            total: questionsData.length,
            showSizeChanger: true,
            showQuickJumper: true,
            position: ["topCenter"],
          }}
          rowClassName={() => "editable-row regular-row"}
          onChange={(pagination, tableFilters, tableSorters: any) => {
            console.log("Pagination changed:", pagination);
          }}
        />
      </div>
    </>
  );
};

export default Questions;
